module.exports = __webpack_public_path__ + "img/QR.830be3b8.png";